export default __webpack_public_path__ + "static/media/Festrahmen.8614105d.jpeg";